import { render, staticRenderFns } from "./CrgoPackaging.vue?vue&type=template&id=4ad95725&"
import script from "./CrgoPackaging.vue?vue&type=script&lang=js&"
export * from "./CrgoPackaging.vue?vue&type=script&lang=js&"
import style0 from "./CrgoPackaging.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrgoPackaging.vue"
export default component.exports